const WeightcontrolForm = document.getElementById('weight-control-calculator');
const close = document.getElementById('weight-control-calculator-close');

WeightcontrolForm.addEventListener('submit', function(event) {
    event.preventDefault();

    const height = parseFloat(document.getElementById('heightCon').value);
    const age = parseInt(document.getElementById('ageCon').value);
    const weight = parseFloat(document.getElementById('weightCon').value);

    const actLevel = parseFloat(document.querySelector('input[name="actlevelCon"]:checked').value);
    const gender = parseFloat(document.querySelector('input[name="genderCon"]:checked').value);
    const actDur = parseFloat(document.querySelector('input[name="actdur"]:checked').value);

    const bmr = (weight * 10) + (height * 6.25) - (5 * age) + gender
    const tdee = bmr * actLevel
    const total = Math.round(tdee + actDur)

    document.querySelector("#update-number-control").textContent = total.toString()
    document.querySelector('.weight-control-calculator-container-result').classList.remove('hidden')


});

close.addEventListener('click', function(event) {
    document.querySelector('.weight-control-calculator-container-result').classList.add('hidden');

});


